import {
  ArrowLeftIcon,
  Dialog,
  DialogBackdrop,
  DialogContent,
  DialogFooter,
  PrimaryButton,
  TertiaryButton,
  useDialogState,
} from '@tricor-digital-team/vistra-design-system';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ReviewDetails from './StepperForm/Components/ReviewDetails/ReviewDetails';
import IndividualSummary from './StepperForm/Components/IndividualDetails/IndividualSummary';
import { format, parseISO } from 'date-fns';
import { AxiosClient } from '../Utils/AxiosClient';

const ApplicationDetail = () => {
  const { id } = useParams(); // ✅ get id from URL

  const navigate = useNavigate();
  const [selectedIndividual, setSelectedIndividual] = useState(null);
  const dialog = useDialogState({ visible: false });
  const [form, setForm] = useState(null); // ✅ local state

  const setIndividual = (data) => {
    setSelectedIndividual(data);
    dialog.show();
  };

  useEffect(() => {
    const fetchForm = async () => {
      try {
        const response = await AxiosClient.get(`/formById/${id}`);
        setForm(response.data);
      } catch (error) {
        console.error('Error fetching form:', error);
      }
    };

    if (id) fetchForm();
  }, [id]);

  const UNIT_AMOUNT = 20000;
  const TAX_AMOUNT = 20;

  let individualTotal = form?.individuals?.length * (UNIT_AMOUNT / 100);
  let individualTax = individualTotal * (TAX_AMOUNT / 100);
  let total = individualTotal + individualTax;

  if (form?.paymentDetails) {
    individualTotal = form?.paymentDetails?.totalWithoutTax;
    individualTax = form?.paymentDetails?.taxValue;
    total = form?.paymentDetails?.paymentAmount;
  }

  return (
    <div className="bg-white shadow-xl rounded-2xl w-full mt-12 pt-12 pb-6 px-[104px] max-w-[1016px]">
      <div className="border-b-2 border-gray-200">
        <TertiaryButton
          icon={ArrowLeftIcon}
          iconPosition="left"
          label="Back"
          onClick={() => {
            navigate('/dashboard');
          }}
          size="large"
          extraClass="mb-6 text-blue-500 font-medium"
        />
      </div>
      <div className="flex justify-between w-full my-12">
        <div className="text-3xl text-gray-700 font-medium">{form?.requestorInformation?.companyName || '-'}</div>
        <div className="text-xs text-gray-700">
          Submission date: {form?.submissionDate ? format(parseISO(form.submissionDate), 'dd MMM yyyy') : ''}
        </div>
      </div>
      <div className="text-black text-2xl font-normal">Total cost</div>
      <div class="overflow-x-auto border-t-2 border-gray-200 mt-6">
        <table class="min-w-full border-collapse">
          <thead class="border-b border-gray-200">
            <tr>
              <th class="py-2 text-xs font-medium text-gray-900 text-left">
                <div class="p-2">Items</div>
              </th>
              <th class="py-2 text-xs font-medium text-gray-900 text-left">
                <div class="p-2">Quantity</div>
              </th>
              <th class="py-2 text-xs font-medium text-gray-900 text-right">
                <div class="p-2">Price (GBP)</div>
              </th>
            </tr>
          </thead>

          <tbody>
            <tr className="border-b border-gray-200">
              <td class="px-2 py-3 text-gray-900 text-sm">Individual Identity Verification</td>
              <td class="px-2 py-3 text-gray-900 text-sm">{'x' + form?.individuals?.length}</td>
              <td class="px-2 py-3 text-gray-900 text-sm text-right">{(individualTotal).toLocaleString('en-UK')}</td>
            </tr>
            <tr className="border-b border-gray-200">
              <td class="px-2 py-3 text-gray-900 text-sm">VAT (per individual)</td>
              <td class="px-2 py-3 text-gray-900 text-sm">{'x' + form?.individuals?.length}</td>
              <td class="px-2 py-3 text-gray-900 text-sm text-right">{(individualTax).toLocaleString('en-UK')}</td>
            </tr>
            <tr className="border-b border-gray-200">
              <td class="p-2 py-2 text-gray-900 text-base font-medium">Total</td>
              <td class="px-2 py-3 text-gray-900 text-sm"></td>
              <td class="px-2 py-3 text-gray-900 text-base text-right font-medium">{(total).toLocaleString('en-UK')}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="mt-12">
        <ReviewDetails customerDetails={form} setIndividual={setIndividual} isFreezed={true} />
      </div>
      <DialogBackdrop id="dialog-backdrop" {...dialog}>
        <Dialog
          id="dialog-container"
          hideOnEsc={false}
          hideOnClickOutside={false}
          {...dialog}
          aria-label="Example Label"
          size={'medium'}
        >
          <DialogContent>
            <IndividualSummary
              isView={true}
              personalDetails={selectedIndividual?.personalDetails}
              currentAddress={selectedIndividual?.currentAddress}
              previousAddress={selectedIndividual?.previousAddress}
              isFreezed={true}
            />
          </DialogContent>
          <DialogFooter>
            <div className="py-3">
              <PrimaryButton
                iconPosition="right"
                label="Close"
                onClick={(e) => {
                  e.preventDefault();
                  setSelectedIndividual(null);
                  dialog.hide();
                }}
                size="large"
              />
            </div>
          </DialogFooter>
        </Dialog>
      </DialogBackdrop>
      <div className="flex items-center mt-[72px]">
        <span className="text-sm text-gray-400">Copyright © 2025 Vistra. All Rights Reserved.</span>
        <div className="h-4 border-l border-gray-300 mx-2"></div>
        <a
          href="https://www.vistra.com/privacy-notice"
          className="text-sm text-blue-500"
          target="_blank"
          rel="noreferrer"
        >
          Privacy policy
        </a>
        <div className="h-4 border-l border-gray-300 mx-2"></div>
        <a
          href="https://www.vistra.com/idv-terms/uk"
          className="text-sm text-blue-500"
          target="_blank"
          rel="noreferrer"
        >
          Terms and conditions
        </a>
      </div>
    </div>
  );
};

export default ApplicationDetail;
